export { default as TermsAndConditions } from './TermsAndConditions';
